import { apiClient } from '../../api/endpointsBackend';

// Shared key for the user's active conversation, so the full /chat page and the
// floating assistant widget continue the same thread (and it lands in history).
export const CHAT_SESSION_KEY = 'mikapital.chat.activeSession';

/**
 * Send a message to the chat agent
 * @param {string} sessionId - Current session ID (optional)
 * @param {string} message - User message
 * @returns {Promise<{sessionId: string, response: string, timestamp: string}>}
 */
export const sendMessage = async (sessionId, message) => {
  const response = await apiClient.post('/chat/messages', {
    message,
    session_id: sessionId || null,
  });
  return response.data;
};

/**
 * Clear chat history for a session
 * @param {string} sessionId - Session ID to clear
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const clearSession = async (sessionId) => {
  if (!sessionId) {
    return { success: true, message: 'No session to clear' };
  }
  await apiClient.delete(`/chat/sessions/${sessionId}`);
  return { success: true, message: 'Session cleared' };
};

/**
 * Get all chat sessions for the user
 */
export const getSessions = async () => {
  const response = await apiClient.get('/chat/sessions');
  return response.data;
};

/**
 * Get messages for a specific session
 */
export const getSessionMessages = async (sessionId) => {
  const response = await apiClient.get(`/chat/sessions/${sessionId}/messages`);
  return response.data;
};
